import React from "react";
import { reportClientError } from "@/lib/clientLog";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "", stack: "", componentStack: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Something went wrong.", stack: error?.stack || "" };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App error boundary:", error, info);
    this.setState({ componentStack: info?.componentStack || "" });
    reportClientError("react-error-boundary", {
      message: error?.message,
      stack: error?.stack,
      componentStack: info?.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh", display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center", textAlign: "center",
          background: "#0C1E44", color: "#FAF7F0", fontFamily: "Georgia, serif", padding: "24px",
        }}>
          <img src="/logo-crest.png" alt="West Ouachita Cabinets" style={{ height: 96, borderRadius: 3, marginBottom: 24 }} />
          <h1 style={{ fontSize: 28, fontWeight: 300, margin: 0 }}>We hit a snag loading the site</h1>
          <p style={{ color: "#A9B7CE", marginTop: 12, maxWidth: 460, lineHeight: 1.6, fontFamily: "Manrope, sans-serif" }}>
            Please refresh the page. If it keeps happening, try a private window or a different browser.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 24, background: "#D4AF37", color: "#0C1E44", border: "none",
              padding: "14px 28px", textTransform: "uppercase", letterSpacing: "0.15em",
              fontSize: 13, cursor: "pointer", fontFamily: "Manrope, sans-serif", fontWeight: 600,
            }}
          >
            Reload
          </button>
          <details style={{ marginTop: 28, maxWidth: 680, width: "100%", textAlign: "left" }}>
            <summary style={{ cursor: "pointer", color: "#D4AF37", fontFamily: "Manrope, sans-serif", fontSize: 12, letterSpacing: "0.12em", textTransform: "uppercase" }}>
              Show technical details
            </summary>
            <pre style={{
              marginTop: 12, whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 12,
              color: "#A9B7CE", background: "rgba(0,0,0,0.25)", padding: 16, borderRadius: 4,
              fontFamily: "monospace", maxHeight: 320, overflow: "auto",
            }}>
              {`Error: ${this.state.message}\n\n${this.state.stack || ""}\n\nComponent stack:${this.state.componentStack || ""}`}
            </pre>
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}
